import React, { useState, useEffect } from "react";
import axios from "axios";
import { environment } from "../../../environment.js";
import { Button } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import NavbarNew from "../../Components/NavbarNew.js";
const { SearchBar } = Search;

const MySwal = withReactContent(Swal);

const SupportAdminTickets = (history) => {
  const [data, setData] = useState([]);

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    axios
      .get(
        environment.dap_url + "support/getAllActiveSupports?id=" + user.parentId
      )
      .then((response) => {
        console.log(response.data);
        setData(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const defaultSorted = [
    {
      dataField: "id",
      order: "desc",
    },
  ];

  const deleteTicket = (id) => {
    Swal.fire({
      title: "Are you sure?",
      icon: "warning",
      showConfirmButton: true,
      showCancelButton: true,
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .delete(environment.dap_url + "support/delete?id=" + id)
          .then((res) => {
            if (res) {
              Swal.fire({
                icon: "success",
                title: "Ticket Deleted",
                showConfirmButton: false,
                timer: 1500,
              }).then((result) => {
                // handleCancel();
                // history.push("/supports");
                window.location.reload();
              });
            }
          });
      }
    });
  };

  const columns = [
    {
      dataField: "id",
      text: "#",
      formatter: (row, col, rowIndex, formatExtra) => {
        return rowIndex + 1;
      },
    },
    {
      dataField: "createdAt",
      text: "Date",
      formatter: (dataField) => {
        return dataField.split("T")[0];
      },
    },
    {
      dataField: "ticketId",
      text: "Ticket Id",
    },
    {
      dataField: "customer_details",
      text: "Customer Name",
      formatter: (dataField) => {
        if (dataField.length > 0) {
          return dataField[0].userFirstName + " " + dataField[0].userLastName;
        } else {
          return "";
        }
      },
    },
    {
      dataField: "priority",
      text: "Priority",
    },
    {
      dataField: "excutive_details",
      text: "Assigned To",
      formatter: (dataField) => {
        if (dataField.length > 0) {
          return dataField[0].userFirstName + " " + dataField[0].userLastName;
        } else {
          return "";
        }
      },
    },
    {
      dataField: "status",
      text: "Status",
      // formatter:(dataField)=>{
      //     if(dataField == "closed"){
      //         return "Closed"
      //     }
      //     return dataField
      // }
    },
    {
      dataField: "_id",
      text: "Action",
      formatter: (row, cell, rowIndex, formatExtra) => {
        return (
          <div style={{ display: "flex", flexDirection: "row" }}>
            <div>
              <LinkContainer to={`/supports/ViewTicket/` + cell._id}>
                <Button variant="primary" className="btn-sm">
                  <i className="fa fa-eye"></i>
                </Button>
              </LinkContainer>
            </div>
            <div>
              <LinkContainer to={`/supports/editTicket/` + cell._id}>
                <Button
                  variant="info"
                  className="btn-sm"
                  disabled={cell.status == "closed" ? true : false}
                >
                  <i className="fa fa-edit"></i>
                </Button>
              </LinkContainer>
            </div>
            <div>
              <Button
                variant="danger"
                className="btn-sm"
                onClick={(e) => {
                  deleteTicket(cell._id);
                }}
                disabled={cell.status == "closed" ? true : false}
              >
                <i className="fa fa-trash"></i>
              </Button>
            </div>
          </div>
        );
      },
    },
  ];

  return (
    <div class="container-fluid">
      <NavbarNew />

      <div className="row">
        <div className="col-lg-11">
          <LinkContainer
            to={`/supports/createticket`}
            style={{
              float: "right",

              background: "#5271FF",
              marginBottom: "20px",
              color: "white",
              radius: "8px",
            }}
          >
            <Button variant="light" className="btn-lg">
              New Ticket
            </Button>
          </LinkContainer>
        </div>
      </div>
      <div className="row">
        <h3 className="card-title" style={{ paddingLeft: "39px" }}>
          TICKETS
        </h3>
      </div>
      <div style={{ marginLeft: "4%", marginRight: "4%" }}>
        <div className="row">
          <div className="col-12">
            <ToolkitProvider
              keyField="id"
              bootstrap4
              data={data}
              columns={columns}
              search
            >
              {(props) => (
                <div>
                  <div className="d-flex align-items-center">
                    <p className="mb-2 mr-2">Search in table:</p>
                    <SearchBar {...props.searchProps} />
                  </div>
                  <BootstrapTable
                    defaultSorted={defaultSorted}
                    pagination={paginationFactory()}
                    {...props.baseProps}
                    wrapperClasses="table-responsive"
                  />
                </div>
              )}
            </ToolkitProvider>
            {/* <BootstrapTable keyField='id' data={data} columns={columns} /> */}
          </div>
        </div>
      </div>
    </div>
  );
};
export default SupportAdminTickets;
